import { __assign, __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { GET_CORP_SHARE_AUTH_INFO, SET_CORP_SHARE_AUTH_INFO, } from './cgi-path';
import { INetworkRequestService } from '../../base/request/network-request.interface';
import { IDocMetaDomainService } from '../../doc-meta/service/doc-meta-domain-service.interface';
import { COMMON_COOKIES_KEYS, getCookieByCommonKey } from '@tencent/ark-utils/lib/cookie';
var CorpShareAuthRepository = /** @class */ (function () {
    function CorpShareAuthRepository(docMetaDomainService, networkRequestService) {
        this.docMetaDomainService = docMetaDomainService;
        this.networkRequestService = networkRequestService;
    }
    /**
     * 设置企业账号对外分享权限
     */
    CorpShareAuthRepository.prototype.changeCorpShareAuthInfo = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var uid, corpId, isOpen, canExternalApply, docCorpSharePolicy, params;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        uid = options.uid, corpId = options.corpId, isOpen = options.isOpen, canExternalApply = options.canExternalApply, docCorpSharePolicy = options.docCorpSharePolicy;
                        params = {
                            user_info: {
                                uid: uid,
                                corp_id: corpId,
                            },
                            doc_id: this.docMetaDomainService.docMetaEntity.padInfo.padId,
                            is_open: isOpen,
                            can_external_apply: canExternalApply,
                            uint32_policy: Math.round(Number(docCorpSharePolicy || 2)),
                            xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf),
                        };
                        return [4 /*yield*/, this.networkRequestService.instance.post(SET_CORP_SHARE_AUTH_INFO, __assign({}, params))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CorpShareAuthRepository.prototype.fetchCorpShareAuthInfo = function (uid, corpId) {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            user_info: {
                                uid: uid,
                                corp_id: corpId,
                            },
                            doc_id: this.docMetaDomainService.docMetaEntity.padInfo.padId,
                            xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf),
                        };
                        return [4 /*yield*/, this.networkRequestService.instance.post(GET_CORP_SHARE_AUTH_INFO, __assign({}, params))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CorpShareAuthRepository = __decorate([
        __param(0, IDocMetaDomainService),
        __param(1, INetworkRequestService),
        __metadata("design:paramtypes", [Object, Object])
    ], CorpShareAuthRepository);
    return CorpShareAuthRepository;
}());
export default CorpShareAuthRepository;
